<template>
  <v-card tabindex="-1">
    <!-- This is the result -->
    <result-node v-bind:key="result.order" :node="result" :rootID="result.id"> </result-node>

    <!-- This is the meta data -->
    <v-row no-gutters class="">
      <v-col class="caption px-4 pt-2 grey--text">
        Updated {{ result.branchLastUpdated | formatDate('fromNow') }}
      </v-col>
      <v-col class="caption px-4 pt-2 grey--text" :style="`color: ${backgroundColor};`">
        Score {{ result.score.toPrecision(3) }}
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { computed, ref } from '@vue/composition-api';
import useWorkspace from '@/views/Context/use/useWorkspace';
import useSearch from '@/views/Context/use/useSearch';

export default {
  props: {
    result: Object,
    maxChildren: {
      default: 2,
      type: Number
    }
  },
  components: {},
  setup(props) {
    const backgroundColor = computed(() => {
      let color;
      if (props.result.score < -10) {
        color = '#C8E6C9';
      } else if (props.result.score < -9) {
        color = '#B3E5FC';
      } else if (props.result.score < 0) {
        color = '#FFE0B2';
      } else {
        color = 'white';
      }
      return color;
    });
    const { showSearch, toggleShowSearch, toggleShowQuickSearch } = useSearch();
    const { openInTab } = useWorkspace();
    return {
      backgroundColor,
      openInTab,
      showSearch,
      toggleShowSearch,
      toggleShowQuickSearch
    };
  }
};
</script>

<style>
.section-link:hover {
  background: #f6f6f6;
  cursor: pointer;
}
</style>
